import type { ModalConfig } from "./types";

export const recurringTransactionModalsModalUrlConfig = {
  // Recurring Transaction Modals
  "recurring-transactions-detail": {
    modalId: "recurring-transactions-detail",
    entityName: "recurring-transactions",
    singularParam: "recurringTransactionId",
    pluralParam: "recurringTransactionsId",
    displayName: "Recurring Transaction",
  },
} as const satisfies Record<string, ModalConfig>;
